import { defineSlotRecipe } from '@chakra-ui/react';
import { dialogAnatomy, drawerAnatomy } from '@chakra-ui/react/anatomy';
// Deep-merge over Chakra's default dialog and drawer recipes: the shadow goes
// (house rule, no shadows), and a hairline sets the panel apart instead, as the
// menu and popover recipes do.
export const dialogRecipe = defineSlotRecipe({
    className: 'chakra-dialog',
    slots: dialogAnatomy.keys(),
    base: {
        content: {
            boxShadow: 'none',
            borderWidth: '1px',
            borderColor: 'border',
        },
    },
});
export const drawerRecipe = defineSlotRecipe({
    className: 'chakra-drawer',
    slots: drawerAnatomy.keys(),
    base: {
        content: {
            boxShadow: 'none',
            borderWidth: '1px',
            borderColor: 'border',
        },
    },
});
